import React, { useState } from "react";
import "firebase/auth";
import { useFirebaseApp, useUser } from "reactfire";
import { Redirect } from "react-router-dom";
import "./css.css";

export default function Sesion() {
  const [loading, setLoading] = useState(false);
  const handleSetLoading = (value) => {
    setLoading(value);
  };

  const [data, setData] = useState({ user: "", password: "" });
  const handleSetData = (d) => {
    setData(d);
  };

  const handleInputChange = (e) => {
    const target = e.target;
    const name = target.name;
    handleSetData({ ...data, [name]: target.value });
  };

  const firebase = useFirebaseApp();

  const handleOnClick = async (e) => {
    e.preventDefault();
    handleSetLoading(true);
    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(data.user, data.password);
    } catch (error) {
      handleSetLoading(false);
      console.log(error);
    }
  };

  if (useUser()) return <Redirect to="/" />;
  return (
    <div className="login-page">
      <div className="form">
        {!loading ? (
          <form className="login-form" onSubmit={handleOnClick}>
            <input
              type="text"
              placeholder="Usuario"
              name="user"
              onChange={handleInputChange}
              value={data.user}
            />
            <input
              type="password"
              placeholder="Contraseña"
              name="password"
              onChange={handleInputChange}
              value={data.password}
            />

            <button onClick={handleOnClick}>INGRESAR</button>
          </form>
        ) : (
          <div className="cargando"></div>
        )}
      </div>
    </div>
  );
}
